<template>
    <b-overlay :show="loading">
      <template v-if="hasDrilldowns">
        <div class="text-center mt-3 mb-3">
            <h4>While you wait, check out our latest 5-Minute Drill Down video!</h4>
            <h6>Fast, focused insights on essential clinical topics.</h6>
        </div>
        <lobby-drilldowns :ch="classHash" :sh="studentHash" :darr="drilldowns"></lobby-drilldowns>
      </template>
      <template v-if="hasPodcasts">
        <div class="text-center mt-3 mb-3">
            <h4>While you wait, check out our recent podcast episodes!</h4>
        </div>
        <lobby-podcasts :ch="classHash" :sh="studentHash" :parr="podcasts"></lobby-podcasts>
      </template>
      <div v-if="!hasDrilldowns && !hasPodcasts">
        <!-- No drilldowns or podcasts..? -->
      </div>
  </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import LobbyDrilldowns from "@/components/LobbyDrilldowns"
import LobbyPodcasts from "@/components/LobbyPodcasts"

export default {
  name: "LobbyLive",    // Used with ClassroomLive
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      busy: false,
      success: false,
      loading: true,
      classHash: null,
      studentHash: null,
      drilldowns: [],
      podcasts: [],
    }
  },
  props: {
    ch: {  // class hash
      type: String,
      default: null
    },
    sh: {  // student hash
      type: String,
      default: null
    }
  },
  components: {
    'lobby-drilldowns': LobbyDrilldowns,
    'lobby-podcasts': LobbyPodcasts
  },
  computed: {
    hasDrilldowns() {
      return (this.drilldowns.length != 0)
    },
    hasPodcasts() {
      return (this.podcasts.length != 0)
    }
  },
  methods: {
  },
  created() {
    if (this.debug) console.log(`Created LobbyLive`)
    this.classHash = this.ch    // class or podcast
    this.studentHash = this.sh

    this.loading = true
    service
        .getWebinarLobby(this.classHash, null, this.studentHash, 'webinar')
        .then(
            (res => {
                if (this.debug) console.log(res)
                if (res.status && res.rowCount !== 0) {
                  if (res.drilldowns.status) {
                    this.drilldowns = res.drilldowns.data
                  }
                  else if (res.podcasts.status) {
                    this.podcasts = res.podcasts.data
                  }
                }
                else {
                    this.error = true
                    this.errorMsg = "Server error. Try later."
                }
            }).bind(this)
        )
        .finally(e => {
            this.loading = false
            if (this.debug) console.log(`finally LobbyLive...`)
        })
        .catch(e => {
            this.error = true
            this.errorMsg = "Error accessing API."
            console.log(e)
        })
  },
  mounted() {
    if (this.debug) console.log(`Mounted LobbyLive`)
    // this.busy = false
    // this.success = false
  },
  beforeDestroy() {
    if (this.debug) console.log(`BeforeDestroy LobbyLive`)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LobbyLive.vue